/*
 * ---------------------------------------------------------------------
 * Player Action Types
 * ---------------------------------------------------------------------
 */
export const SET_PLAYER = "SET_PLAYER";
